"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class SystemService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    static healthcheck() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/healthcheck',
        });
    }
}
exports.SystemService = SystemService;
